import { useTranslation } from "react-i18next";
import { CSSTransition } from "react-transition-group";
import { useRef } from "react";

const ContactFormMessage = (props) => {
    const { t } = useTranslation();
    const errorRef = useRef();
    const successRef = useRef();
    let alertClassess = ['alert'];

    if (props.error) {
        alertClassess.push('alert-danger');
    }
    if (props.sent) {
        alertClassess.push('alert-success');
    }

     return (
        <>
            <CSSTransition
                nodeRef={errorRef}
                in={props.error}
                timeout={500}
                classNames='fade'
                unmountOnExit>
                <div className={alertClassess.join(' ')} ref={errorRef}>
                    <ul className='errorList'>
                        {
                            props.error
                                ? props.error.map(e =>
                                    <li key={e}>{t('contact.form.errorMessages.' + e)}</li>
                                )
                                : null


                        }
                    </ul>
                </div>
            </CSSTransition>
            <CSSTransition
                nodeRef={successRef}
                in={props.sent}
                timeout={500}
                classNames='fade'
                unmountOnExit>
                <div className={alertClassess.join(' ')} ref={successRef}>
                    {t('contact.form.successfullSent')}
                </div>
            </CSSTransition>
        </>
    ); 





    /* console.log(props);
    if (props.error) {
        alertClassess.push('alert-danger');
        return (
            <div className={alertClassess.join(' ')}>
                <ul className='errorList'>
                    {
                        props.error.map(e =>
                            <li key={e}>{t('contact.form.errorMessages.' + e)}</li>
                        )

                    }
                </ul>
            </div>
        );
    }

    if (props.sent) {
        alertClassess.push('alert-success');
        return (
            <div className={alertClassess.join(' ')}>
                {t('contact.form.successfullSent')}
            </div>
        );
    } */
}

export default ContactFormMessage;